import React from 'react';
import { useIntl } from 'react-intl';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import messages from '../../../locale/jsonMessages';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { getPurchaseServicePlanValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import cs from '../../../components/commonStyle.css';


const CancelServicePlanModalBody = ({ modalData }) => {
  const { value } = modalData;
  const { formatMessage, locale } = useIntl();
  const planDetails = JSON.parse(value?.dynamicServicePlanDetails || '[]');
  const matchPlan = getPurchaseServicePlanValue(planDetails, locale)
  const planName = matchPlan?.planName ? matchPlan?.planName : value?.servicePlanName;
  return (
    <div>
      <p className={cx(cs.commonSmallText16, cs.spaceBottom2)}>{formatMessage(messages.servicePlanCancelTitle)}</p>
      <p className={cx(cs.commonSmallText16, cs.spaceBottom2)}>
        <span className={cs.fontWeightBold}>{formatMessage(messages.planNameLabel)}:&nbsp;</span>{planName}
      </p>
      <p className={cx(cs.commonSmallText16, cs.spaceBottom2)}><span className={cs.fontWeightBold}>{formatMessage(messages.priceLabel)}:&nbsp;</span>
        <span className={cs.displayInlineBlock}>
          <CurrencyConverter
            amount={value?.price}
            from={value?.currency} />
          {" / "}{value?.duration}{" "}{value?.duration == 1 ? formatMessage(messages.month) : formatMessage(messages.monthsLabel)}
        </span>
      </p>
      <p className={cx(cs.commonSmallText16, cs.spaceBottom4)}>{formatMessage(messages.servicePlanCancelSubTitle)}</p>
      <p className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.spaceBottom1)}>{formatMessage(messages.cancelPlanModalLabel02)}</p>
      <ul className={cx(cs.commonSmallText16, cs.bulletList, cs.noMargin, cs.dFlexColumn, cs.gap6)}>
        <li>{formatMessage(messages.servicePlanCancelPoint01)}</li>
        <li>{formatMessage(messages.servicePlanCancelPoint02)}</li>
        <li>{formatMessage(messages.servicePlanCancelPoint03)}</li>
      </ul>
    </div>
  );
}

export default withStyles(cs)(CancelServicePlanModalBody);

